import Chapter from 'components/Chapter';
import CircleGraph from 'components/CircleGraph';
import ChartTitle from 'components/ChartTitle';
import InView from 'components/InView';
import { vizTitle, viz, respondents } from 'copy/intro.txt';

const IntroViz = ({ copy }) => (
	<Chapter section={1}>
		{vizTitle.map((t, i) => (
			<ChartTitle tag="p" tight>
				{t.text}
			</ChartTitle>
		))}

		<p>{respondents}</p>

		<InView render={inView => <CircleGraph data={viz} inView={inView} />} />
	</Chapter>
);

export default IntroViz;



// WEBPACK FOOTER //
// ./components/IntroViz/index.js